import { Routes, RouterModule } from '@angular/router';

import { ShellComponent } from './shell.component';

const routes: Routes = [
    {
        path: '',
        component: ShellComponent,
        children: [
            {
                path: 'artists',
                loadChildren: () => import('../artists/artists.module').then((m) => m.ArtistsModule),
            },
            {
                path: 'venues',
                loadChildren: () => import('../venues/venues.module').then((m) => m.VenuesModule),
            },
        ],
    },
];

export const ROUTING = RouterModule.forChild(routes);
